import { FiPhone } from "react-icons/fi";
import { TbMessage2 } from "react-icons/tb";

const TravelDetails = ({ stops, vehicalId }) => {
  const present = stops.find((stop) => stop.status === "Planned");

  return (
    <>
      <h2 className="text-lg font-semibold">Current Travel Details</h2>
      {!!present && (
        <div className="flex items-center justify-between">
          {present.name && (
            <div className="pr-2">
              <p className="text-xs text-gray-400">Purpose of Travel</p>
              <p className="">Presentation Delivery</p>
              <p className="text-sm">{present.name}</p>
            </div>
          )}
          {present.phoneNumber && (
            <div className="flex gap-3 mt-2">
              <a
                href={`tel:${present.phoneNumber}`}
                className="p-2 rounded-md bg-[#361D3214]"
              >
                <FiPhone color="#361D32" size={24} />
              </a>
              <button className="p-2 rounded-md bg-[#361D3214] relative">
                <TbMessage2 color="#361D32" size={24} />
                <span className="size-2 bg-red-600 absolute right-2 top-2 rounded-full" />
              </button>
            </div>
          )}
        </div>
      )}

      {!!vehicalId && (
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-400 font-medium mt-2">Vehicle ID</p>
            <p className="font-semibold">{vehicalId}</p>
          </div>
          <img
            src="/vehicle.png"
            alt="vehicle"
            className="w-40 h-16 object-contain"
          />
        </div>
      )}

      {/* Stops */}
      <div className="mt-3">
        {stops.length > 0 ? (
          <div className="flex flex-col space-y-5 relative">
            {/* Vertical Line */}
            <div className="absolute left-[17px] top-[51%] -translate-y-1/2 bottom-0 w-0.5 border-l-2 border-dashed border-gray-200 h-[73%]"></div>

            {stops.map((stop, index) => (
              <div key={index} className="flex items-start space-x-3 relative">
                {/* Step circle */}
                <div className="relative z-10">
                  <img
                    src={
                      index === stops.length - 1
                        ? "/location.svg"
                        : "/marker.svg"
                    }
                    alt="location-pin"
                    className="size-10"
                  />
                </div>

                {/* Content */}
                <div className="flex justify-between w-full">
                  <div>
                    <h3 className="text-sm font-semibold text-gray-800 pr-3 line-clamp-2">
                      {stop.name}
                    </h3>
                    <p className="text-xs text-gray-400">
                      {index === stops.length - 1
                        ? "Final Destination"
                        : stop.status}
                    </p>
                  </div>
                  <span
                    className={`text-xs font-medium text-gray-600 whitespace-nowrap`}
                  >
                    {stop.time}
                  </span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-center font-medium text-sm">No Visits Found</p>
        )}
      </div>
    </>
  );
};

export default TravelDetails;
